// Array de API Keys de Groq — una por cada cuenta gratuita que tengas
// Cada cuenta de Groq tiene su propio rate limit. Poniendo varias aquí
// el sistema las va rotando en orden (round-robin) para maximizar capacidad.
//
// Ejemplo con 3 cuentas:
// export const GROQ_API_KEYS = [
//   'gsk_CLAVE_CUENTA_1',
//   'gsk_CLAVE_CUENTA_2',
//   'gsk_CLAVE_CUENTA_3',
// ];
export const GROQ_API_KEYS = [
  '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', // cuenta 1 // cuenta 2
];

// Round-robin: usamos las keys en orden secuencial para distribuir la carga uniformemente
let _keyIndex = 0;
const getNextKey = () => {
  if (!GROQ_API_KEYS.length) return '';
  const key = GROQ_API_KEYS[_keyIndex % GROQ_API_KEYS.length];
  _keyIndex = (_keyIndex + 1) % GROQ_API_KEYS.length;
  return key;
};

export const generateGroqAssistantContent = async (prompt, options = {}) => {
  const {
    model = 'openai/gpt-oss-120b', // Modelo por defecto si no viene de la config
    temperature = 0.45,
  } = options;

  const apiKey = getNextKey();

  if (!apiKey) {
    throw new Error('No hay API keys configuradas para Groq.');
  }

  const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
      model,
      temperature,
      messages: [
        {
          role: 'user',
          content: prompt
        }
      ]
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data?.error?.message || 'HTTP ' + response.status;
    throw new Error(message);
  }

  const text = String(data?.choices?.[0]?.message?.content || '').trim();

  if (!text) {
    throw new Error('Groq API no devolvió texto útil.');
  }

  return {
    text,
    model: String(data?.model || model),
    provider: 'groq',
  };
};

export default generateGroqAssistantContent;
